import lazyload from 'lazyload'

import Checkbox from './classes/Checkbox'
import Search from './classes/Search'
import ContactForm from './classes/ContactForm'
import MobileMenu from './classes/MobileMenu'
import SiteMessages from './classes/SiteMessages'

new MobileMenu()
new Search()
new SiteMessages()
new lazyload()

const faqCards = document.querySelectorAll('.faq-card')
faqCards.forEach((faqCard) => {
    const faqTrigger = faqCard.querySelector('.faq-card-trigger')

    faqTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        faqCard.classList.toggle('active')
    })
})

const checkboxes = document.querySelectorAll('.checkbox')
checkboxes.forEach((checkbox) => new Checkbox(checkbox))

const contactForms = document.querySelectorAll('.contact-form-container')
contactForms.forEach((contactForm) => new ContactForm(contactForm))
